import { Component,
    Input,
    ElementRef,
    Renderer,
    OnChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { TreeComponent, TreeService, TreeNode } from '../../../../../common/tree';
import { ContextMenuHolderComponent
} from '../../../../../common/context-menu/context-menu-holder.component';
import { ContextMenuService } from '../../../../../common/context-menu/context-menu.service';
import { ContextMenuDirective } from '../../../../../common/context-menu/context-menu.directive';
import { ServiceHeaderDirective } from '../../../service-header/service-header.directive';
import { InventoryService } from '../../services/inventory.service';
import { Subscription } from 'rxjs/Rx';
import { Autofocus } from '../../../../../common/auto-focus/auto-focus.directive';
const _ = require('lodash');
import { Router, ActivatedRoute, Params } from '@angular/router';
import  inventoryRouteMapper  from '../../inventory-route-mapper';
import { RefreshSharedService } from '../../../../refresh-shared-service';

@Component({
    selector: 'network-tree-holder',
    providers: [ InventoryService, ContextMenuService, TreeService ],
    styles: [
        require('./network-tree-holder.scss')
    ],
    encapsulation: ViewEncapsulation.None,
    template: require('./network-tree-holder.html')
})

export class NetworkTreeHolder implements OnChanges {
    @Input() state: any;
    @Input() set linksMap(linksMap: any) {};
    @Input() set actionsMap(actionsMap: any) {};
    @Input() networkTreeVisible: boolean;

    private selectedSearchType: any = '1';
    private nodes: any = [];
    private originalNodes: any = [];
    private subscription: Subscription;
    private menuActionMapping = {};
    private menuLinksMapping = {};
    private refresh: Subscription;
    private nodeToBeSelectedOnLoad: any;

    private options = {
        idField: 'entity_id',
        displayField: 'name',
        childrenField: 'children',
        getChildren: this.getChildren.bind(this),
        getIconClass: this.getIconClass.bind(this),
        isExpandedField: 'expanded',
        hasContextMenu: false,
        contextMenuActionMapping: this.menuActionMapping,
        menuLinksMapping: this.menuLinksMapping,
        typeField: 'entityType',
        leafTypes: ['directConnect', 'gateway', 'orgVdcNetwork']
    };

    @ViewChild(TreeComponent)
    private tree: TreeComponent;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private idsFromUrl = {
        'item': '',
        'ids': [],
        'entity_id': ''
    };
    private isNetworkTreeLoaded = false;
    private componentIds: any;
    constructor(public inventoryTree: InventoryService,
                private elementRef: ElementRef,
                private renderer: Renderer,
                private treeService: TreeService,
                private router: Router,
                private route: ActivatedRoute,
                private rss: RefreshSharedService) {
        this.rsService = rss;
        this.componentIds = [
            'directconnects',
            'directconnect/',
            'vdcnetworks',
            'vdcnetwork/',
            'gateways',
            'gateway/',
            'networks'
        ];
    }

    getElementReference() {
        return this.elementRef;
    }

    ngOnInit() {
        let url: string = location.href;
        let item: string;
        let id: string;
        let pos: number;
        for (let i = 0; i < this.componentIds.length; i++) {
            item = this.componentIds[i];
            if (url.indexOf(item) >= 0) {
            // listing page
                if (item.substr(item.length - 1) === 's') {
                    this.idsFromUrl = {
                        'item': item,
                        'ids': [],
                        'entity_id': ''
                    }
                    break;
                } else {
            // details page
                    pos = url.indexOf(item);
                    if (pos === -1) {
                        continue;
                    }
                    id = url.substring(pos + item.length);
                    if (!id) {
                        continue;
                    }
                    this.idsFromUrl = {
                        'item': item.substring(0, item.length - 1),
                        'ids': [id],
                        'entity_id': ''
                    }
                    break;
                }
            }
       }
        this.tree.treeService.setIdsFromUrl(this.idsFromUrl);
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
            this.handleEmittedValues(item);
        });
        this.nodeToBeSelectedOnLoad = location.href.match(/([^\/]*)\/*$/)[1];
    }

  handleEmittedValues(item) {
    if (item.shouldReloadInventoryTree) {
         this.treeRefresh(this.tree);
    }
  }

  selectNode() {
      if (this.idsFromUrl) {
                let treeNode = this.tree.treeService.getNodeById(this.idsFromUrl.entity_id);
                if (!treeNode) {
                    return;
                }
                let item = this.idsFromUrl.item;
                if (item.substr(item.length - 1) === 's') {
                    treeNode.blur();
                    treeNode.focus()
                } else {
                    treeNode.expand();
                }
        }
  }

    ngOnChanges(changes) {
        if (changes && !changes.state) {
            return;
        }

        this.isNetworkTreeLoaded = false;
        this.subscription = this.inventoryTree.getNetworkTreeRootNodes().subscribe(nodes => {
                this.nodes = nodes;
                this.originalNodes = nodes;
                this.options = {
                    idField: 'entity_id',
                    displayField: 'name',
                    childrenField: 'children',
                    getChildren: this.getChildren.bind(this),
                    getIconClass: this.getIconClass.bind(this),
                    isExpandedField: 'expanded',
                    hasContextMenu: false,
                    contextMenuActionMapping: this.menuActionMapping,
                    menuLinksMapping: this.menuLinksMapping,
                    typeField: 'entityType',
                    leafTypes: ['directConnect', 'gateway', 'orgVdcNetwork']
                };
            },
            error => { console.log('Error on loading tree'); },
            () => {
              setTimeout(() => {
                    if (this.idsFromUrl.item.indexOf('directconnect') >= 0) {
                            this.idsFromUrl.entity_id = this.nodes[0].children[0].entity_id
                    } else if (this.idsFromUrl.item.indexOf('vdcnetwork') >= 0) {
                            this.idsFromUrl.entity_id = this.nodes[0].children[1].entity_id;
                    } else if (this.idsFromUrl.item.indexOf('gateway') >= 0) {
                            this.idsFromUrl.entity_id = this.nodes[1].entity_id;
                    } else if (this.idsFromUrl.item.indexOf('networks') >= 0) {
                            this.idsFromUrl.entity_id = this.nodes[0].entity_id;
                    }
                    let networksNode = this.tree.treeService.getNodeById(this.nodes[0].entity_id);
                    if (networksNode) {
                        networksNode.expand();
                    }
                    this.selectNode();
                }
              );
            }
        );
    }

    ngOnDestroy() {
        if( this.subscription) {
            this.subscription.unsubscribe();
        }
        if( this.refresh) {
            this.refresh.unsubscribe();
        }
        if( this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
        this.rsService.resetParam();
        localStorage.removeItem('lastNetworkRoute');
    }

    getChildren(node) {
        // TODO: This has to be a generic file. Should move this code to some place else.
        let childUrl: String;
        if ( node.data.entityType == "gateways" ) {
            childUrl = '/hybridity/api/vcd/networks/inventory/query?entityType=gateway';
        } else if ( node.data.entityType == "directConnects" ) {
            childUrl = '/hybridity/api/vcd/networks/inventory/query?entityType=directConnect';
        } else if ( node.data.entityType == "transitNetworks" ) {
            childUrl = '';
        } else if ( node.data.entityType == "orgVdcNetworks" ) {
            childUrl = '/hybridity/api/vcd/networks/inventory/query?entityType=orgVdcNetwork';
        }
        return this.inventoryTree.getChildNodes(childUrl);
    }

    getIconClass(node) {
        switch (node.data.entityType) {
            case 'networks':
                return 'tree-node-icon';
            case 'gateways' || 'gateway':
                return 'tree-node-icon';
            case 'directConnects' || 'directConnect':
                return 'tree-node-icon';
            case 'transitNetworks'|| 'transitNetwork':
                return 'tree-node-icon';
            case 'orgVdcNetworks' || 'orgVdcNetwork':
                return 'tree-node-icon';
            default:
                return 'tree-node-icon';
        }
    }

    onNodeSelection = ($event) => {
        if (!this.networkTreeVisible) {
            return;
        }
        let type = $event.node && $event.node && $event.node.data && $event.node.data.entityType ? $event.node.data.entityType : '',
        routePath = inventoryRouteMapper[type],
        id = $event.node && $event.node && $event.node.data && $event.node.data.entity_id ? $event.node.data.entity_id : '';
        if( type == 'networks' || type == 'gateways' || type == 'directConnects' || type == 'orgVdcNetworks' ) {
            localStorage.setItem('lastNetworkRoute', routePath);
            this.router.navigate([ routePath ], { relativeTo: this.route });
        } else {
            localStorage.setItem('lastNetworkRoute', routePath + '/' + id);
            this.router.navigate([ routePath, id ], { relativeTo: this.route });
        }
    };

    onEvent = ($event) => {
    };

    onTreeInit = ($event) => {
    };

    onFocus = ($event) => {
    };

    treeFilter(tree, value) {
        tree.treeService.filterNodes(value, true);
    }

    treeRefresh(tree) {
        tree.treeService.prepareRefresh();
        this.refresh = this.inventoryTree.getNetworkTreeRootNodes().subscribe(nodes => {
                this.nodes = nodes;
                this.originalNodes = nodes;
            }, error => { console.log('Error on loading tree'); },
               () => { tree.treeService.afterFirstLevelLoad(); }
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/components/inventory-main/network-tree/network-tree-holder/network-tree-holder.component.ts